import React, { useMemo } from 'react'
import { FormInterface } from 'src/shared/entities/form/form.schema'
import { FormCheckboxInterface } from 'src/shared/entities/form/form-checkbox-sub-entity.schema'
import { CommonPublisherCheckboxEntityOrSubEntity } from '../../shared/components/common-publisher-checkbox-entity-or-sub-entity'
import { CheckboxesErrorsType, useFormContext } from './context/form-context'

interface FormCheckboxSubEntityProps {
  formEntity: FormInterface
  checkboxSubEntity: FormCheckboxInterface
}

export const FormCheckboxSubEntity = ({
  formEntity,
  checkboxSubEntity,
}: FormCheckboxSubEntityProps) => {
  const { checkboxesValues, setCheckboxesValues, setCheckboxesErrors } =
    useFormContext()
  const entity = useMemo(
    () => ({
      ...checkboxSubEntity,
      ...formEntity.checkboxesCommonStyles,
    }),
    [checkboxSubEntity, formEntity.checkboxesCommonStyles],
  )
  return (
    <CommonPublisherCheckboxEntityOrSubEntity
      entityOrSubEntity={entity}
      checked={checkboxesValues[checkboxSubEntity.id]}
      onChange={() => {
        setCheckboxesValues(prev => ({
          ...prev,
          [checkboxSubEntity.id]: !prev[checkboxSubEntity.id],
        }))
        setCheckboxesErrors(prev =>
          Object.entries(prev).reduce((acc, [key, value]) => {
            if (key !== checkboxSubEntity.id) {
              acc[key] = value
            }
            return acc
          }, {} as CheckboxesErrorsType),
        )
      }}
    />
  )
}
